import { z } from 'zod';
import { OMIT_ERROR } from '#validation/common/constants';
import { createErrorHandler } from './helpers/error-handler';
export const stringValidator = ({ requiredError, invalidError, minLength, maxLength, length, formats = [], openApiFormat, } = {}) => {
    let validator = z.string({
        error: createErrorHandler(requiredError, invalidError),
    });
    if (minLength) {
        validator = validator.min(minLength.min, minLength.error);
    }
    if (maxLength) {
        validator = validator.max(maxLength.max, maxLength.error);
    }
    if (length) {
        validator = validator.length(length.len, length.error);
    }
    for (const format of formats) {
        validator = validator.regex(format.regex, format.error);
    }
    if (openApiFormat) {
        validator = validator.regex(openApiFormat, OMIT_ERROR);
    }
    return validator;
};
